var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15.241,
    viewBox: "0 0 20 15.241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-sign-out-alt",
    "data-name": "Icon awesome-sign-out-alt",
    d: "M19.723,12.793,13.056,19.46a.954.954,0,0,1-1.627-.675v-3.81h-5.4a.95.95,0,0,1-.952-.952v-3.81a.95.95,0,0,1,.952-.952h5.4V5.452a.955.955,0,0,1,1.627-.675l6.667,6.667A.961.961,0,0,1,19.723,12.793Zm-12.1,6.469V17.675a.478.478,0,0,0-.476-.476H3.81a1.269,1.269,0,0,1-1.27-1.27V8.309a1.269,1.269,0,0,1,1.27-1.27H7.143a.478.478,0,0,0,.476-.476V4.976A.478.478,0,0,0,7.143,4.5H3.81A3.811,3.811,0,0,0,0,8.309v7.619a3.811,3.811,0,0,0,3.81,3.81H7.143A.478.478,0,0,0,7.619,19.262Z",
    transform: "translate(0 -4.499)",
    fill: "#ce4760"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiconnect);
export default __webpack_public_path__ + "static/media/diconnect.a287fc1cc39b7b6329f8c37836b6d913.svg";
export { ForwardRef as ReactComponent };